module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.fff614a0.svg";